import { validation } from '@/util/validation.js';
export default {
  submitText: '变更',
  emptyBtn: false,
  column: [
    {
      label: 'id',
      display: false,
      prop: 'id',
      span: 8,
    },
    {
      label: '所属车场',
      type: 'tree',
      prop: 'spaceId',
      span: 8,
      editDisabled: true,
      disabled: true,
      search: true,
      cell: true,
      props: {
        label: 'title',
        value: 'key',
      },
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0',
    },
    {
      label: '车辆身份',
      editDisabled: true,
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_manage_type',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      // dataType: 'number',
      prop: 'carManageType',
      // search: true,
      disabled: true,
    },
    {
      label: '车牌号',
      disabled: true,
      prop: 'plateNumber',
      span: 8,
    },
    {
      label: '车辆大小',
      editDisabled: true,
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_type_v2',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      // dataType: 'number',
      prop: 'bigOrSmallCar',
      search: true,
      disabled: true,
    },
    {
      label: '主/副车',
      span: 8,
      disabled: true,
      type: 'select',
      dicData: [{
        dictValue:'副车',
        dictKey:0,
      },{
        dictValue:'主车',
        dictKey:1,
      }],
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      // dataType: 'number',
      prop: 'isMainCar',
    },
    {
      label: '车位编号',
      prop: 'parkingSpaceNames',
      type: 'input',
      span: 8,
      disabled: true,
    },
    {
      label: '关联主车',
      prop: 'mainPlateNumber',
      type: 'input',
      span: 8,
      disabled: true,
    },
    {
      label: '租赁起期',
      prop: 'effectTime',
      span: 8,
      type: 'date',
      format: 'yyyy-MM-dd 00:00:00',
      valueFormat: 'yyyy-MM-dd 00:00:00',
      editDisabled: true,
      disabled: true,
      display:false,
      rules: [
        {
          required: true,
          message: '请输入租赁起期',
          trigger: 'change',
        },
      ],
    },
    // {
    //   label: '收费套餐',
    //   prop: 'ruleName',
    //   span: 8,
    //   disabled: true,
    // },

    {
      label: '租赁止期',
      prop: 'expiredTime',
      type: 'date',
      format: 'yyyy-MM-dd 23:59:59',
      valueFormat: 'yyyy-MM-dd hh:mm:ss',
      span: 8,
      // labelslot:true,
      // formslot:true,
      disabled: true,
      display:false,
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },
      ],
    },
    // {
    //   label: '应收金额',
    //   prop: 'shouldMoney',
    //   span: 8,
    //   disabled: true,
    //   rules: [
    //     {
    //       required: false,
    //       message: '请输入应收金额',
    //       trigger: 'change',
    //     },
    //   ],
    // },
    {
      label: '车主',
      span: 8,
      search: true,
      prop: 'personName',
      disabled: true,
      rules: [
        {
          message: '请输入车主',
          trigger: 'change',
        },
      ],
    },
    {
      label: '车主电话',
      prop: 'personPhone',
      disabled: true,
      span: 8,
      search: true,
      /* rules: [
        {
          message: '请输入客户手机号',
          trigger: 'change',
        },
      ],*/
    },

    {
      label: '状态',
      prop: 'status',
      display: false,
    },
    {
      label: '操作',
      prop: 'operateType',
      display: false,
    },
    // {
    //   label: '车位编号',
    //   prop: 'parkingSpaceNames',
    //   hide: true,
    //   disabled: true,
    //   span: 8,
    //   rules: [
    //     {
    //       required: false,
    //       message: '请输入停车车位编号',
    //       trigger: 'change',
    //     },
    //   ],
    // },
    {
      label: '公司住所',
      prop: 'roomName',
      hide: true,
      disabled: true,
      span: 8,
      rules: [
        {
          required: false,
          message: '请输入公司住所',
          trigger: 'change',
        },
      ],
    },
    {
      label: '新车牌号',
      hide: true,
      prop: 'newPlateNumber',
      span: 8,
      rules: [
      {
        required: true,
        message: '请输入新车牌号',
        trigger: 'change',
      },
        {
          required: true,
          message: '车牌号格式错误',
          pattern: validation.carPlate,
          trigger: 'change',
        },
        /*{
          pattern: /^([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}(([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领A-Z]{1}[A-Z]{1}[A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳]{1})$/,
          message: '车牌号格式错误',
          trigger: 'blur',
        },*/
      ],
    },
    {
      label: '车型大小',
      editDisabled: true,
      span: 8,
      type: 'select',
      dicUrl: '/api/blade-system/dict/dictionary?code=car_type_v2',
      props: {
        label: 'dictValue',
        value: 'dictKey',
      },
      // dataType: 'number',
      prop: 'newBigOrSmallCar',
      search: true,
      rules: [
        {
          required: false,
          message: '请输入车型大小',
          trigger: 'change',
        },
      ],
      // disabled: true,
    },
    {
      label: '授权区域',
      prop: 'regions',
      type: 'input',
      span: 24,
      formslot:true,
      // display: false,
    },
    {
      label: '备注说明',
      prop: 'description',
      hide: true,
      span: 24,
      type: 'textarea',
      rules: [
        {
          required: false,
          message: '请输入备注说明',
          trigger: 'change',
        },
      ],
    },
  ],
};
